const TOPITEM = [
  {
    id:'1',
    name:'몽클레어 패딩1',
    price:1200000,
    img: require('../assets/images/top_item.png'),
    sellCount:10,
    delivery:0
  },
  {
    id:'2',
    name:'몽클레어 패딩2',
    price:1200000,
    img: require('../assets/images/top_item.png'),
    sellCount:20,
    delivery:0
  },
  {
    id:'3',
    name:'몽클레어 패딩3',
    price:1200000,
    img: require('../assets/images/top_item.png'),
    sellCount:30,
    delivery:0
  },
  {
    id:'4',
    name:'몽클레어 패딩4',
    price:1200000,
    img: require('../assets/images/top_item.png'),
    sellCount:40,
    delivery:0
  },
  {
    id:'5',
    name:'몽클레어 패딩5',
    price:1200000,
    img: require('../assets/images/top_item.png'),
    sellCount:50,
    delivery:0
  },
  {
    id:'6',
    name:'몽클레어 패딩6',
    price:1200000,
    img: require('../assets/images/top_item.png'),
    sellCount:60,
    delivery:0
  },
]

export default TOPITEM;